import React from 'react';
import { COLORS, CONTENT_COLUMN, FONTS, META } from '../../globalStyles';

// Chrome and base typography for the site's standalone document pages (/legal, the 404).
//
// These pages are DOCUMENTS, not sections of the marketing site: one narrow column, generous
// leading, no glass panels competing with the text, and no hero signature behind them. The
// treatment mirrors public/privacy.html, which is the site's other document page — if the h2
// rule or the footer changes in one, it should change in both.
export const styles: Record<string, React.CSSProperties> = {

  // Same CONTENT_COLUMN and 6vw gutters as the marketing sections, so a SandwichContainer
  // here is exactly as wide as one in the Products section. The vertical padding is the
  // page's own — a document opens near the top rather than 7rem down.
  page: {
    ...CONTENT_COLUMN,
    padding: '2rem 6vw 5rem',
    color: COLORS.text,
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1rem',
    paddingBottom: '3.5rem',
  },
  brand: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.7rem',
    textDecoration: 'none',
    color: COLORS.text,
  },
  wordmark: {
    fontFamily: FONTS.body,
    fontSize: '1.25rem',
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: '0.26em',
    // Cancels the trailing letter-space so the wordmark sits flush with what follows it.
    marginRight: '-0.26em',
    color: COLORS.text,
  },
  headerActions: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.6rem',
  },
  closeButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '34px',
    height: '34px',
    background: 'transparent',
    border: `1px solid ${COLORS.borderStrong}`,
    borderRadius: 0,
    color: COLORS.muted,
    cursor: 'pointer',
  },

  footer: {
    marginTop: '4rem',
    paddingTop: '2rem',
    borderTop: `1px solid ${COLORS.borderStrong}`,
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1rem',
  },
  footerCopy: {
    ...META,
    fontSize: '0.62rem',
    color: COLORS.faint,
  },
  footerBack: {
    ...META,
    fontSize: '0.62rem',
    textDecoration: 'none',
    color: COLORS.muted,
  },

  // Shared document typography. Imported by the pages' own styles.ts so there is one
  // definition rather than a copy per page.
  title: {
    fontFamily: FONTS.display,
    fontStretch: '125%',
    fontWeight: 600,
    fontSize: 'clamp(2rem, 5vw, 3rem)',
    letterSpacing: '-0.02em',
    lineHeight: 1.05,
    margin: '0 0 3rem 0',
    color: COLORS.text,
  },
  paragraph: {
    fontFamily: FONTS.body,
    fontSize: '1rem',
    // Long-form prose wants more leading than UI copy.
    lineHeight: 1.75,
    color: COLORS.muted,
    margin: '0 0 1rem 0',
  },
  link: {
    color: COLORS.accent,
    textUnderlineOffset: '2px',
  },
};
